module.exports = __webpack_public_path__ + "img/wr_4.a70fe675.png";